<template>
    <div class="services-page">


  
      <!-- Services Section -->
      <ServicesSection />
    </div>
  </template>
  
  <script>
  // Import the HeroSection and ServicesSection components

  import ServicesSection from './ServicesSection.vue';
  
  export default {
    name: 'ServicesPage',
    components: {
      ServicesSection,
    },
  };
  </script>
  
  <style scoped>
  .services-page {
    font-family: Arial, sans-serif;
  }
  </style>
  